var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTrackingPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 96,
    viewBox: "0 0 84 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C14.7 0 12 2.7 12 6V90C12 93.3 14.7 96 18 96H78C81.3 96 84 93.3 84 90V24L60 0H18Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 24H84L60 0V18C60 21.3 62.7 24 66 24Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 42L66 24H84V42Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78C72 79.65 70.65 81 69 81H3C1.35 81 0 79.65 0 78V48C0 46.35 1.35 45 3 45H69C70.65 45 72 46.35 72 48V78Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0771 56.8411C13.0771 56.0491 13.7011 55.1851 14.7061 55.1851H20.2471C23.3671 55.1851 26.1751 57.2731 26.1751 61.2751C26.1751 65.0671 23.3671 67.1791 20.2471 67.1791H16.2421V70.3471C16.2421 71.4031 15.5701 72.0001 14.7061 72.0001C13.9141 72.0001 13.0771 71.4031 13.0771 70.3471V56.8411ZM16.2421 58.2061V64.1821H20.2471C21.8551 64.1821 23.1271 62.7631 23.1271 61.2751C23.1271 59.5981 21.8551 58.2061 20.2471 58.2061H16.2421Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8732 72.0001C30.0812 72.0001 29.2172 71.5681 29.2172 70.5151V56.8891C29.2172 56.0281 30.0812 55.4011 30.8732 55.4011H36.3662C47.3282 55.4011 47.0882 72.0001 36.5822 72.0001H30.8732ZM32.3852 58.3291V69.0751H36.3662C42.8432 69.0751 43.1312 58.3291 36.3662 58.3291H32.3852Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9761 58.5209V62.3339H57.0931C57.9571 62.3339 58.8211 63.1979 58.8211 64.0349C58.8211 64.8269 57.9571 65.4749 57.0931 65.4749H50.9761V70.5119C50.9761 71.3519 50.3791 71.9969 49.5391 71.9969C48.4831 71.9969 47.8381 71.3519 47.8381 70.5119V56.8859C47.8381 56.0249 48.4861 55.3979 49.5391 55.3979H57.9601C59.0161 55.3979 59.6401 56.0249 59.6401 56.8859C59.6401 57.6539 59.0161 58.518 57.9601 58.518H50.9761V58.5209Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81H12V84H69C70.65 84 72 82.65 72 81V78C72 79.65 70.65 81 69 81Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTrackingPdf);
export default __webpack_public_path__ + "static/media/live_tracking_pdf.bc707ad62b4425a80a5ca49984035ef0.svg";
export { ForwardRef as ReactComponent };